import { jsxs, jsx } from "react/jsx-runtime";
const VisualisationClusteredColumnChartIcon = (props) => /* @__PURE__ */ jsxs("svg", { ...props, viewBox: "0 0 1024 1024", children: [
  /* @__PURE__ */ jsx(
    "rect",
    {
      x: "64",
      y: "888",
      width: "896",
      height: "72",
      rx: "32",
      fill: "black",
      fillOpacity: "0.65"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M128 96C128 78.3269 142.327 64 160 64H252C269.673 64 284 78.3269 284 96V784C284 801.673 269.673 816 252 816H160C142.327 816 128 801.673 128 784V96Z",
      fill: "#0A3A83"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M552 224C552 206.327 566.327 192 584 192H676C693.673 192 708 206.327 708 224V784C708 801.673 693.673 816 676 816H584C566.327 816 552 801.673 552 784V224Z",
      fill: "#0A3A83"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M316 416C316 398.327 330.327 384 348 384H440C457.673 384 472 398.327 472 416V784C472 801.673 457.673 816 440 816H348C330.327 816 316 801.673 316 784V416Z",
      fill: "#5CBAEB"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M740 480C740 462.327 754.327 448 772 448H864C881.673 448 896 462.327 896 480V784C896 801.673 881.673 816 864 816H772C754.327 816 740 801.673 740 784V480Z",
      fill: "#5CBAEB"
    }
  )
] });
export {
  VisualisationClusteredColumnChartIcon
};
